import ENV from "../env";

const createPartnerParticipant = async ({ eventId, partnerId, tickets, details, subdivision }) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/participant/partner/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      eventId,
      partnerId,
      tickets,
      details,
      subdivision,
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.error || data?.message || "Partner participant creation failed");
  }

  return data.participant;
};

export default createPartnerParticipant;
